import apiClient from './apiClient';

export interface ArchiveCategory {
  id?: number;
  category_code: string;
  category_name: string;
  archive_type: 'debtor' | 'credit' | 'hris' | 'legal' | 'general';
  applicable_modules?: string[];
  is_mandatory: boolean;
  validity_unit?: 'permanent' | 'days' | 'months' | 'years';
  requires_validation: boolean;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface ArchiveCategoryFilters {
  archive_type?: string;
  is_active?: boolean;
  search?: string;
}

const archiveCategoryApi = {
  getAll: (filters?: ArchiveCategoryFilters) => {
    let endpoint = '/archive/categories';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<ArchiveCategory[]>(endpoint);
  },

  getById: (id: number) => {
    return apiClient.get<ArchiveCategory>(`/archive/categories/${id}`);
  },

  create: (data: Partial<ArchiveCategory>) => {
    return apiClient.post<ArchiveCategory>('/archive/categories', data);
  },

  update: (id: number, data: Partial<ArchiveCategory>) => {
    return apiClient.put<ArchiveCategory>(`/archive/categories/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/archive/categories/${id}`);
  },
};

export default archiveCategoryApi;
